declare const RICH_TEXT_BRAND: unique symbol;

/**
 * CMS-neutral rich-text primitive.
 *
 * A branded string carrying HTML (Sitecore JSS RichText) or a serialized
 * portable-text equivalent (Sanity). Treated as opaque by `@eneco/cms`; the
 * presentation layer is responsible for safe rendering.
 */
export type RichText = string & { readonly [RICH_TEXT_BRAND]: 'RichText' };

/**
 * Cast a plain string into the `RichText` brand. Adapters call this once
 * after they've validated and (when relevant) sanitized the markup.
 */
export const asRichText = (value: string): RichText => value as RichText;
